<template>
  <div class="tablediv box">
    <div class="box_f1 box box_v">
      <dv-decoration-7>　{{title}}　</dv-decoration-7>
      <div class="box_f1">
        <dv-border-box-8>
          <dv-scroll-board :config="config" />
        </dv-border-box-8>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'csscAllTable',
    computed: {
      xiaofeiquanVue() {
        return this.$store.state.xiaofeiquanVue
      },
    },
    created() {
      this.config = this.getConfig([['', '', '', '']])
      //GET api/coupon-count/top
      //超市、商场排行统计TOP，按照消费总金额倒叙排列
      //discountCouponTypeNO 01--超市，02--商场
      if(this.type=='supermarket' || this.type=='hypermarket') {
        this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/top', {
          discountCouponTypeNO: this.type=='supermarket'?'01':'02'
        },request=> {
          let data = request.rows.map(item=> {
            return ['<span title="'+item.companyName+'">'+item.companyName+'</span>',
              '<span title="'+item.goodsAmount+'">'+this.toThousands(item.goodsAmount, true)+'</span>',
              '<span title="'+item.consumeNum+'">'+this.toThousands(item.consumeNum, true)+'</span>',
              '<span title="'+item.groupName+'">'+item.groupName+'</span>']
          })
          this.config = this.getConfig(data)
        })
      }
    },
    methods: {
      getConfig(data) {
        if(data.length<1) {
          data = [['', '', '', '']]
        }
        return {
          header: ['名字', '消费额', '核销(张)', '所属集团'],
          data: data,
          index: true,
          waitTime: 3000,
          headerBGC: 'rgba(29, 193, 245,.5)',
          oddRowBGC: '',
          evenRowBGC: '',
          columnWidth: [35, 110],
          align: ['center', 'left', 'center','center','center']
        }
      },
      toThousands(num, bol) {
        num = parseInt(num)
        let result = [ ], counter = 0;
        num = (num || 0).toString().split('')
        for (let i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i != 0) { result.unshift(','); }
        }
        if(bol) {
          return result.join('')
        }else {
          return result
        }
      }
    },
    data () {
      return {
        config: {}
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="less">
  .tablediv {
    position: relative;
    width: 100%;
    height: 50%;

    .dv-scroll-board {
      height: 100%;
    }
    .dv-border-box-8 {
      .border-box-content {
        padding: 10px!important;
      }
    }
    .dv-decoration-7 {
      height: 25px;
      margin: 20px 0px!important;
      font-size: 16px;
    }
  }
</style>
